enum ShippingFrequency {
  Monthly    = 'monthly',
  BiMonthly  = 'biMonthly',
  TriMonthly = 'triMonthly',
}


const getFrequencyNameByShippingPeriod = (shippingPeriod: number): ShippingFrequency => {
  let frequencyValue = ShippingFrequency.Monthly

  if (shippingPeriod === 2) {
    frequencyValue = ShippingFrequency.BiMonthly
  }
  else if (shippingPeriod === 3) {
    frequencyValue = ShippingFrequency.TriMonthly
  }

  return frequencyValue
}


export default getFrequencyNameByShippingPeriod
